var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHourglass(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4076 -14489)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    transform: "translate(4076 14489)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1769.737 14569.452)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2361.213,55.022c-1.585,0-3.169,0-4.753,0-1.088,0-1.444-.36-1.383-1.433a9.713,9.713,0,0,1,2.253-5.8c.952-1.144,1.919-2.273,2.883-3.407.717-.844,1.285-.866,2-.013,1.221,1.448,2.467,2.88,3.6,4.4a8.6,8.6,0,0,1,1.567,4.862c.046,1.059-.3,1.391-1.341,1.393Q2363.626,55.025,2361.213,55.022Z",
    transform: "translate(-36.959 -105.036)",
    fill: "#58beb3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2326.14-26.521a10.732,10.732,0,0,1,2.112-5.87c1.16-1.558,2.312-3.123,3.5-4.66a.69.69,0,0,0,0-1c-1.126-1.465-2.217-2.956-3.339-4.423a11.13,11.13,0,0,1-2.265-5.821c-.108-1.124.222-1.628,1.008-1.613a.855.855,0,0,1,.928.955,8.849,8.849,0,0,0,2.1,5.533c1.283,1.614,2.491,3.287,3.728,4.937a1.321,1.321,0,0,1-.025,1.888q-2.046,2.738-4.107,5.465a8.281,8.281,0,0,0-1.689,4.659c-.048.894-.348,1.332-.961,1.334C2326.462-25.136,2326.128-25.6,2326.14-26.521Z",
    transform: "translate(-12.186 -24.886)",
    fill: "#707070",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2420.813-48.274a10.532,10.532,0,0,1-2.075,5.825c-1.153,1.564-2.3,3.129-3.5,4.66a.719.719,0,0,0,.005,1.055c1.125,1.464,2.227,2.945,3.332,4.424a10.23,10.23,0,0,1,2.216,6.47.888.888,0,0,1-.928.968.836.836,0,0,1-.963-.857c.088-2.931-1.577-5.044-3.245-7.172-.873-1.114-1.711-2.255-2.559-3.388a1.3,1.3,0,0,1-.013-1.94c1.218-1.635,2.421-3.281,3.689-4.877a8.747,8.747,0,0,0,2.1-5.46c0-.483.147-.979.7-1.011a1.441,1.441,0,0,1,1.056.368C2420.841-48.967,2420.779-48.491,2420.813-48.274Z",
    transform: "translate(-86.244 -25.168)",
    fill: "#707070",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2324.263-77.069q-5.581,0-11.164,0c-.847,0-1.221-.3-1.211-.96.01-.626.386-.951,1.179-.952q11.2-.008,22.4,0c.878,0,1.277.442,1.146,1.174-.106.592-.489.745-1.042.743-3.458-.012-6.915-.006-10.372-.006Z",
    transform: "translate(0 0)",
    fill: "#707070",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2324.246,139.079h-10.875a6.252,6.252,0,0,1-.647-.015.823.823,0,0,1-.788-.868.871.871,0,0,1,.728-1,2.487,2.487,0,0,1,.5-.028q11.128,0,22.254,0a2.683,2.683,0,0,1,.5.026.862.862,0,0,1,.747.984c-.02.522-.264.881-.828.892-.913.017-1.825.011-2.737.012Z",
    transform: "translate(-0.039 -184.998)",
    fill: "#707070",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHourglass);
export default __webpack_public_path__ + "static/media/hourglass.ec3d9591.svg";
export { ForwardRef as ReactComponent };